import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ReferenceDataCategoriesConstants, ReferenceDataOptionLists, ReferenceDataService } from 'rome-library';
import { SwitchDataResponseDto } from '../../interfaceTypes/sharedFeatures/online-product-switch/models/switch-data-response-dto.model';
import { TagManagerConstants } from '../constants/tag-manager-constants';

@Injectable()
export abstract class TaggingService {
  protected dataLayer: any = {};
  protected readonly isTagManEnabled: boolean;

  public abstract sendDataLayer(): void;

  constructor(
    protected readonly referenceDataService: ReferenceDataService,
    protected readonly gtmService: GoogleTagManagerService
  ) {
    this.isTagManEnabled =
      this.referenceDataService.getConfigurationValueByCode(
        ReferenceDataCategoriesConstants.CLIENT_ENVIRONMENT_CATEGORY,
        TagManagerConstants.TagManagerConfigName,
        TagManagerConstants.AvailabilityFlag
      ) === ReferenceDataOptionLists.AnswerTypeYes;
  }

  public initialize(): void {
    if (this.isTagManEnabled) {
      void this.gtmService.addGtmToDom();
    }
  }

  public execute(): void {
    this.sendDataLayer();
  }

  public resetDataLayer(): void {
    this.dataLayer = {};
  }

  public sendSwitchDataLayer(switchObj: SwitchDataResponseDto): void {
    if (!this.isTagManEnabled) {
      return;
    }

    const tmParam = {};
    tmParam[TagManagerConstants.SwitchCaseIdParamName] = switchObj.SwitchCaseID;
    tmParam[TagManagerConstants.SwitchTaskIdParamName] = switchObj.SwitchTaskID;
    tmParam[TagManagerConstants.ProductSelectedParamName] = switchObj.ProductSelected;
    tmParam[TagManagerConstants.TermExtensionParamName] = switchObj.TermExtension;
    tmParam[TagManagerConstants.TermReductionParamName] = switchObj.TermReduction;
    tmParam[TagManagerConstants.EventParamName] = TagManagerConstants.EventSwitchCaseCreated;

    void this.gtmService.pushTag(tmParam);
  }
}
